export default __webpack_public_path__ + "static/media/max-wheel-img.224b27ee.png";